<header class="app-header ids-color-bg-brand-primary">
	<img [src]="logo" />
</header>
